export default function CourseTerms() {
    return (
        <>
            <section id="guitar-course-details-section">
                <div className="guitar-course-details-container">
                    <div className="guitar-course-details-content">
                        <div className="course-detail-item">
                            <h3 className="course-detail-title">TRAINING INVOLVES</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Posture, bowing techniques, and finger placement.</li>
                                <li>Scales, arpeggios, and sight-reading.</li>
                                <li>Improvisation, tone development, and expression.</li>
                                <li>Western classical & Indian violin training.</li>
                                <li>Solo and ensemble performance practice.</li>
                            </ul>
                        </div>

                        <div className="course-detail-item">
                            <h3 className="course-detail-title">Who is it For</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Beginners taking up violin as their first instrument.</li>
                                <li>Intermediate students polishing technique.</li>
                                <li>Advanced musicians preparing for concerts & exams.</li>
                                <li>Certification aspirants (Trinity/ABRSM).</li>
                            </ul>
                        </div>

                        <div className="course-detail-item">
                            <h3 className="course-detail-title">Learning Outcomes</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Confident violin playing with accurate tone and intonation.</li>
                                <li>Ability to perform solos and group ensembles.</li>
                                <li>Readiness for international graded exams.</li>
                                <li>Expression across genres – classical, film, and contemporary.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
} 